// Social Media Integrations Index
// Exports all social media integration components

// Auto-register integrations
import { registerFacebookInstagramIntegration } from './registerFacebookInstagramIntegration';
import { registerLinkedInIntegration } from './registerLinkedInIntegration';
import { registerTwitterIntegration } from './registerTwitterIntegration';

// Facebook/Instagram Integration
export { FacebookInstagramIntegration } from './FacebookInstagramIntegration';
export { FacebookInstagramIntegrationFactory, type FacebookInstagramConfig } from './FacebookInstagramIntegrationFactory';
export { 
  registerFacebookInstagramIntegration,
  getFacebookInstagramIntegrationMetadata,
  validateFacebookInstagramConfig,
  getFacebookInstagramSetupInstructions
} from './registerFacebookInstagramIntegration';

// LinkedIn Integration
export { LinkedInIntegration } from './LinkedInIntegration';
export { LinkedInIntegrationFactory, type LinkedInConfig } from './LinkedInIntegrationFactory';
export { registerLinkedInIntegration } from './registerLinkedInIntegration';

// Twitter Integration
export { TwitterIntegration } from './TwitterIntegration';
export { TwitterIntegrationFactory, type TwitterConfig } from './TwitterIntegrationFactory';
export { registerTwitterIntegration } from './registerTwitterIntegration';

// Re-export base social integration types
export {
  BaseSocialIntegration,
  type SocialPlatform,
  type SocialPost,
  type SocialEngagement,
  type SocialAudience,
  type CrossChannelCampaign,
  type CrossChannelMetrics,
  type EngagementData
} from '../base/BaseSocialIntegration';

// Cross-platform utilities
export { CrossPlatformScheduler, type ScheduledContent, type OptimalPostingTime } from './CrossPlatformScheduler';
export { 
  SocialMediaAnalytics, 
  type CrossPlatformMetrics, 
  type EngagementTrend, 
  type TopPerformingContent,
  type AudienceInsights,
  type SocialMediaReport
} from './SocialMediaAnalytics';

// Register all social media integrations on module load
registerFacebookInstagramIntegration();
registerLinkedInIntegration();
registerTwitterIntegration();